'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, useEffect } from 'react';
import { apiClient } from '@/lib/api/client';
import { useSessionMonitor } from '@/hooks/useSessionMonitor';
import ToastProvider from '@/components/ToastProvider';
import { SnapPixel } from '@/components/SnapPixel';
import NotificationStreamManager from '@/components/NotificationStreamManager';

function SessionMonitorWrapper({ children }: { children: React.ReactNode }) {
  useSessionMonitor();

  return <>{children}</>;
}

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000, // 1 minute
        refetchOnWindowFocus: false,
        retry: false,
      },
    },
  }));


  useEffect(() => {
    apiClient.setQueryClient(queryClient);
  }, [queryClient]);

  return (
    <QueryClientProvider client={queryClient}>
      <SnapPixel />
      <ToastProvider>
        <SessionMonitorWrapper>
            <NotificationStreamManager />
            {children}
        </SessionMonitorWrapper>
      </ToastProvider>
    </QueryClientProvider>
  );
}
